import React, { useState, useEffect } from "react";
import "./SignIn.css";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Navigate } from "react-router-dom";

const apiUrl = "https://maintenance.cscoreentities.devtest.gf.aws.scania.com/loadrunner";

function SignIn() {
  const storedJwt = localStorage.getItem("token");
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [jwt, setJwt] = useState(storedJwt || null);
  const [fetchError, setFetchError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isTokenRefreshed, setIsTokenRefreshed] = useState(false);

  const getJwt = async () => {
    try {
      setJwt(null);
      setIsLoading(true);
      const payload = {
        Username: user,
        Password: password,
      };
      const { data } = await axios.post(
        `${apiUrl}/cognito/api/v1/GetToken`,
        payload
      );
      localStorage.setItem("token", data);
      setJwt(data);
      setIsLoading(false);
      setFetchError(null);

      // PENDING
      // Set code to check if token is expired , then set it as expired
      setIsTokenRefreshed(true);
    } catch (err) {
      localStorage.removeItem("token");
      setFetchError(
        err.response
          ? `${err.message}. ${err.response.data}`
          : `${err.message}.`
      );
      setIsLoading(false);
      setJwt(null);
    }
  };

  useEffect(() => {
    if (jwt) {
      const maskedJwt = `${jwt.slice(0, 4)}...${jwt.slice(-4)}`;
      console.log("JWT token updated:", maskedJwt);
    }
  }, [jwt]);

  function handleUserChange(evt) {
    setUser(evt.target.value);
  }

  function handlePasswordChange(evt) {
    setPassword(evt.target.value);
  }

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <ScaleLoader height="30px" width="10px" color="#4287f5" />
        </div>
      ) : (
        <div style={{ height: "38px", width: "100%", clear: "both" }}></div>
      )}

      {isTokenRefreshed ? (
        <Navigate to="/LoadTestMain" />
      ) : (
        <div className="signup-page">
          <div
            className="signup-page-form"
            style={{ width: "18rem", marginLeft: "40%", marginTop: "10%" }}
          >
            <form className="login-form" style={{ width: "15rem" }}>
              <label>Username:</label>
              <input
                name="Username"
                style={{ width: "15rem" }}
                placeholder="Username"
                type="text"
                onChange={handleUserChange}
                value={user}
              />
              <br />
              <br />
              <label>Password:</label>
              <input
                name="Password"
                style={{ width: "15rem" }}
                placeholder="Password"
                type="password"
                onChange={handlePasswordChange}
                value={password}
              />
            </form>
            <section style={{ marginBottom: "10px" }}>
              <button
                style={{ width: "15rem", marginTop: "2rem" }}
                onClick={getJwt}
              >
                Login
              </button>
              {fetchError && (
                <p style={{ color: "red" }}>
                  <br />
                  {fetchError}
                </p>
              )}
            </section>
          </div>
        </div>
      )}
    </>
  );
}

export default SignIn;
